<div class="sidebar-container" [class.collapsed]="collapsed">
  <div class="left-menus">
    <div class="top-header">
      <img *ngIf="!collapsed" [src]="this.logoPath" alt="Finxone-logo" class="img-fluid logo" />
      <button
        type="button"
        class="collapse-toggle"
        (click)="toggleCollapsed()"
        [title]="collapsed ? 'Expand the menu' : 'Collapse the menu'"
        [attr.aria-expanded]="!collapsed"
        data-testid="nav-collapse-toggle"
      >
        <svg
          class="collapse-icon"
          [class.flipped]="collapsed"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 6L9 12L15 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <div class="menu-header mt-4" *ngIf="!collapsed">
      <div
        class="menu-switcher"
        [class.is-pointer]="userAdmin"
        (click)="userAdmin && toggleDashboardDropdown(); $event.stopPropagation()"
      >
        <span>{{ menuLabel }}</span>
        <svg
          *ngIf="userAdmin"
          class="chevron-icon"
          [class.open]="showDashboardDropdown"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div
          *ngIf="showDashboardDropdown"
          class="show-more-options pb-1"
          (clickOutside)="this.showDashboardDropdown = false"
          (click)="$event.stopPropagation()"
        >
          @for(item of dashboardDropdownItems; track item){
          <span class="dropdown-item is-pointer" (click)="clickDropdownItem(item)"> {{ item.label }} </span>
          }
        </div>
      </div>
    </div>
    <ul class="mt-2 nav pl-0" style="width: -webkit-fill-available">
      <li *ngFor="let menu of menus[activeMenu]" class="main-menu mt-0">
        <div
          *ngIf="!menu.isChild"
          class="menu-link"
          [class.menuActive]="menu.isActive"
          [title]="collapsed ? menu.title : ''"
          (click)="onClickMenu(menu.url)"
        >
          <mat-icon class="side-logo" [svgIcon]="menu.img"></mat-icon>
          <div *ngIf="!collapsed">
            <div [class.active]="menu.isActive" class="menu-title ml-2">
              {{ menu.title }}
            </div>
          </div>
        </div>
        <ng-template [ngIf]="menu.isChild">
          <span class="menu-section-title" *ngIf="!collapsed">{{ menu.title }}</span>
          <div class="menu-section-rule" *ngIf="collapsed"></div>
          <ul class="pl-0">
            <li
              *ngFor="let childMenu of menu.children"
              class="menu-link"
              [class.menuActive]="childMenu.isActive"
              [title]="collapsed ? childMenu.title : ''"
              (click)="onClickMenu(childMenu.url)"
            >
              <mat-icon
                ngClass="{{ childMenu?.imgClass ? childMenu?.imgClass : '' }}"
                class="side-logo"
                [svgIcon]="childMenu.img"
              ></mat-icon>

              <div *ngIf="!collapsed" [class.active]="childMenu.isActive" class="menu-title ml-2">
                {{ childMenu.title }}
              </div>
            </li>
          </ul>
        </ng-template>
      </li>
    </ul>
  </div>

  <div class="profile-container fixed-bottom" [title]="collapsed ? firstName + ' ' + lastName : ''">
    <div class="profile-content">
      <div class="avatar">{{ firstName?.charAt(0) }}{{ lastName?.charAt(0) || '' }}</div>
      <div class="user-info" *ngIf="!collapsed">
        <div class="user-name">{{ firstName }} {{ lastName }}</div>
        <div class="user-email">{{ email }}</div>
      </div>
      <button class="action-button" *ngIf="!collapsed" (click)="logout()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="logout-icon">
          <path
            d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <p-confirmDialog styleClass="publish-confirmation " #cd>
    <ng-template pTemplate="footer">
      <button class="mr-4" type="button" (click)="cd.onReject()">
        {{ sharedConstants.CANCEL }}
      </button>
      <button class="positive" type="button" (click)="cd.onAccept()">
        {{ sharedConstants.LOGOUT }}
      </button>
    </ng-template>
  </p-confirmDialog>
</div>
